import "./Buttons.scss";

interface AuiButtonProps {
  variant:
    | "black-primary"
    | "button-text-styled"
    | "general-text-link"
    | "link-style"
    | "link-style-arrow"
    | "primary"
    | "read-more"
    | "secondary";
  buttontitle: any;
  arialabel?: string;
  buttonid: string;
  buttonclass?: any;
  loading?: boolean;
  disabled?: boolean;
  size?: "extra-large" | "large" | "medium" | "small";
  type?: "button" | "submit" | "reset";
  modalid?: string;
  anchorlinkurl?: string;
  buttonClick?: () => void;
  ifmodal?: boolean
}

const AuiButton: React.FC<AuiButtonProps & React.HTMLAttributes<HTMLElement>> = ({
  variant,
  buttontitle,
  arialabel,
  buttonid,
  buttonclass,
  loading,
  disabled,
  size,
  type,
  anchorlinkurl,
  buttonClick,
  modalid,
  ifmodal,
  ...rest
}) => {
  const handleClick = () => {
    if (buttonClick) {
      buttonClick();
    }
    const event = new Event("buttonClick");
    document.getElementById(buttonid)?.dispatchEvent(event);
  };

  return (
    <aui-button
      variant={variant}
      buttontitle={buttontitle}
      arialabel={arialabel}
      buttonid={buttonid}
      buttonclass={buttonclass}
      loading={loading}
      disabled={disabled}
      size={size}
      type={type}
      onClick={handleClick}
      anchorlinkurl={anchorlinkurl}
      modalid={modalid}
      ifmodal={ifmodal}
      {...rest}
    ></aui-button>
  );
};

export default AuiButton;
